import { InconsistenciesByPeopleModel } from '../../../../models/inconsistencies-validation/inconsistenciesValidation';
import { InconsistenciesValidationRequest } from '../../../../models/inconsistencies-validation/inconsistenciesValidationRequest';
import { requests } from '../apiAgent';

export const InconsistenciesValidationAPI = {
    getAll: (body: InconsistenciesValidationRequest) => {
        return requests
            .post('/dublin/api/v2.0.0/inconsistencies-validation', body)
            .then((response: InconsistenciesByPeopleModel) => response)
            .catch((err) => err);
    },
};
